import {
  Box,
  Breadcrumbs,
  Button,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  Modal,
  Table,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DiscountModal from "../../common/discountModel";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

import ReactToPrint from "react-to-print";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Grid from "@mui/material/Grid";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { UpdateBillCounterSell } from "./updateBillApi";
import { useSelector } from "react-redux";
import { routePath } from "../../constants/routePath";
import MenuSideBar from "../../common/menuSideBar";
import Swal from "sweetalert2";
import PrintBilling from "../../common/printBilling";
import { addBill, updateBil } from "./updateBillApiHandler";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { updateBillValidation } from "./updateBillValidationFunctions";
import { TotalAmount, validationUpdate } from "./updateBillingFunctions";
import Pop from "./pop";
import { isArray } from "lodash";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { addQuetation, updateQuetation } from "./questionApi";
import { validateDate } from "@mui/x-date-pickers/internals";
import QRScanImage from "../../assets/img/icons/qr_scan_Icon.png";
import ItemSidebar from "./ItemsSidebar";
import { ModalHeader } from "../../common/modalHeader";
// import { addBill, updateBil } from "./updateBillApiHandler";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import InputAdornment from '@mui/material/InputAdornment';
import calendar from "../../assets/icon/calendarblack.png";

import {
  addBillCounterSell,
  customerNameByMobile,
} from "../counterSellBilling/counterSellBillingApi";
export default function Quatation({
  quotationData,
  setQuotationData,
  setQuotationModal,
}) {
  const [payloadcollection, setPayloadCollection] = useState([]);
  const [searchItemValue, setSeachItemValue] = useState(""); //Search Itemss

  const [indexTableItem, setIndexTableItem] = useState();
  const navigate = useNavigate();
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [tempCustomerData, setTempCustomerData] = useState({
    customerName: "",
    customerAddress: "",
    mobileNumber: "",
    message: "",
  });
  const [billNoR, setBillNoR] = useState(null);
  const [eventHandle, setEventHandle] = useState(null);

  // const
  const [billData, setbillData] = useState({});
  const updateBillData = null;
  const tableName = useSelector((state) => state.reducer.tableName);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const handleClose3 = () => setOpen3(false);
  const handleClose2 = () => setOpen2(false);
  const componentRef = useRef();
  const [NextBtnDisplay, setNextBtnDisplay] = useState(false);
  const [dateErrors, setDateErrors] = useState({
    quotationDate: false,
    validTill: false,
  });
  const [displayContinue, setDisplayContinue] = useState(false);
  const removeFromPayloadCollection = (item) => {
    let temp = [...payloadcollection];
    temp = temp.filter((elet) => {
      return elet?.itemId != item?.itemId;
    });
    console.log("removefrompayload ", temp);
    setPayloadCollection([...temp]);
  };
  const removeItem = (index) => {
    let arr = [...billData.counterSalesChild];
    arr.splice(index, 1);
    setbillData({
      ...billData,
      counterSalesChild: arr,
    });
  };
  const [displayPayloadcollection, setDisplayPayloadcollection] = useState([]);

  useEffect(() => {
    let arr = [...payloadcollection];
    arr = arr.map((item, index) => {
      return item;
    });
    let obj = {};
    arr.forEach((ele, index) => {
      console.log("ele doc", ele);
      if (obj[ele.employeeMasterId + "_" + ele.itemId]) {
        obj[ele.employeeMasterId + "_" + ele.itemId] = {
          ...obj[ele.employeeMasterId + "_" + ele.itemId],
          employeePayPercentage:
            parseFloat(
              obj[ele.employeeMasterId + "_" + ele.itemId][
                "employeePayPercentage"
              ]
            ) + parseFloat(ele.employeePayPercentage),
        };
      } else {
        obj[ele.employeeMasterId + "_" + ele.itemId] = { ...ele };
      }
    });
    let arrnew = [
      ...Object.keys(obj).map((key, index) => {
        return obj[key];
      }),
    ];
    setDisplayPayloadcollection([...arrnew]);
  }, [payloadcollection]);
  const navigateCallback = () => {
    //   if (Object.keys(updateBillData).length === 0) {
    //     // navigate(routePath.COUNTERSELL);
    //   }
  };
  // useEffect(())

  useEffect(() => {
    console.log("payloadcollectionpayloadcollection ", payloadcollection);
  }, [payloadcollection]);
  useEffect(() => {
    navigateCallback();
    console.log("Update Bill Data ", updateBillData);
    let cp = [];
    let arr = [];
    let obj = {};
    if (updateBillData) {
      cp = [...updateBillData?.counterSalesChild];
      arr = [...updateBillData?.counterSalesChild].filter(
        (item, index, self) =>
          index === self.findIndex((obj) => obj.itemId === item.itemId)
      );
      let obj = { ...updateBillData };
    }

    obj["counterSalesChild"] = arr;

    setPayloadCollection(cp);
    setbillData(obj);
  }, []);
  const previousBillDataRef = useRef(billData?.counterSalesChild);

  useEffect(() => {
    console.log("update payloadcollection ", billData?.counterSalesChild);
  }, [billData?.counterSalesChild]);

  const [CollectionTableItems, setCollectionTableItems] = useState([]);
  useEffect(() => {
    console.log(
      "quotationData counterSalesChild ",
      billData?.counterSalesChild
    );
    console.log("quotationData", quotationData);
    let arr = [];
    if (
      quotationData &&
      CollectionTableItems[indexTableItem]?.tableItems &&
      CollectionTableItems[indexTableItem]?.tableItems?.length > 0
    ) {
      let data = [...quotationData?.items];
      arr = data?.map((ele, index) => {
        let ind = CollectionTableItems[indexTableItem]?.tableItems?.findIndex(
          (item, index) => item?.id == ele?.itemId
        );
        return {
          ...CollectionTableItems[indexTableItem]?.tableItems[ind],
          rate: ele?.unitPrice,
          amount: ele?.totalPrice,
          quantity: ele?.quantity,
        };
        if (ind == -1) {
          return null;
        }
        return ele;
      });
      let index = billData?.counterSalesChild;
      setbillData({ ...quotationData, counterSalesChild: arr });
      // console.log(billData)
    }
  }, [quotationData, CollectionTableItems[indexTableItem]?.tableItems]);
  console.log("@@@###", CollectionTableItems);
  const payableValueCalculate = () => {
    let sum = sumItemPrice().sum;

    let discountPrice = (billData?.discount / 100) * sum;
    if (billData?.discountType === "Percent") {
      return sum - (discountPrice ? discountPrice : 0);
    } else {
      return sum - (billData?.discount ? billData?.discount : 0);
    }
  };

  // const removeMatchingElements = (payloadcollectionTemp, newAdataremoveDataFn) => {
  //   // Filter out the elements in payloadcollectionTemp that are NOT in newAdataremoveDataFn
  //   const removedElements = payloadcollectionTemp.filter(payloadItem =>
  //     !newAdataremoveDataFn.some(removeItem => removeItem.itemId === payloadItem.itemId)
  //   );

  //   // Return only the elements that were not present in newAdataremoveDataFn
  //   return removedElements;
  // };

  const sumItemPrice = () => {
    let sum = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    billData?.counterSalesChild?.forEach((item) => {
      sum +=
        item.amount +
        (item.amount ?? 0 * item.sgst ?? 0) / 100 +
        (item.amount ?? 0 * item.igst ?? 0) / 100 +
        (item.amount ?? 0 * item.cgst ?? 0) / 100;
      cgst += (item.amount ?? 0 * item.cgst ?? 0) / 100;
      sgst += (item.amount ?? 0 * item.sgst ?? 0) / 100;
      igst += (item.amount ?? 0 * item.igst ?? 0) / 100;
    });
    return {
      sum: sum,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
    };
  };
  useEffect(() => {}, [billData]);
  const updateBillFunction = (callback) => {
    const valid = validationUpdate(billData);
    let payload = { ...billData };
    let arrpayloadCollection = [...payloadcollection];
    arrpayloadCollection = arrpayloadCollection.filter((ele) => ele != null);
    arrpayloadCollection = arrpayloadCollection.map((ele, index) => {
      let calcaltedPrice = calculatedPriceWitrhDiscount(
        ele.amount,
        discoundedPrice({
          allAmount: addAllValue(billData.counterSalesChild ?? []),
          billData,
        })
      );
      return {
        ...ele,
        employeePayPercentage: parseFloat(ele.employeePayPercentage),
        employeePayPercentage: parseFloat(ele.employeePayPercentage),
        cgstAmount: (calcaltedPrice * (ele.cgst ?? 1)) / 100,
        sgstAmount: (calcaltedPrice * (ele.sgst ?? 1)) / 100,
        igstAmount: (calcaltedPrice * (ele.igst ?? 1)) / 100,
        amount: calculatedPriceWitrhDiscount(
          ele.amount,
          discoundedPrice({
            allAmount: addAllValue(billData.counterSalesChild ?? []),
            billData,
          })
        ),
      };
    });
    payload.counterSalesChild = arrpayloadCollection;
    console.log("payloadpayloadpayload ", payload);
    // return;
    if (valid.status) {
      addBill(
        {
          ...payload,
          customer: payload.customer ? payload.customer : "Cash bill",
          customerMobile: payload.customerMobile ?? "",
          isCounterSalesBill: payload.paymentMode === "Credit" ? false : true,
          paymentMode: payload.paymentMode ?? "Cash",
          discountType: payload.discountType ?? "Amount",
          // discount: parseFloat(payload.discount??0),
          settleBill: true,
          // counterSalesChild: [],
          discount: payload?.discount ? parseFloat(payload?.discount) : 0,
        },
        addBillCounterSell,
        Swal,
        navigate,
        routePath,
        (res) => {
          setBillNoR(3);
          if (callback) {
            // callback({ ...res, customerMobile: payload?.customerMobile, payload: { ...payload } })
            setEventHandle({
              billNumber: res?.data?.data?.billNumber,
              customerMobile: payload?.customerMobile,
            });
            clearCollectionArray();
          } else {
            setPayloadCollection([]);
            setbillData({});
            arrFormat();
            clearCollectionArray();
          }
          setDisplayContinue(false);
          setNextBtnDisplay(false);
        }
      );
    } else {
      Swal.fire({
        title: valid.msg,
        text: "",
        icon: "error",

        ...swalAlertPopProps,
      });
    }
  };
  // ................
  const [collectionTableItemsduplicate, setCollectionTableItemsduplicate] =
    useState([]);

  useEffect(() => {
    if (CollectionTableItems && CollectionTableItems.length > 0) {
      const duplicated = CollectionTableItems.map((collection) => ({
        ...collection,
        tableItems: collection.tableItems
          ? collection.tableItems.map((item) => ({
              ...item,
              quantity: 0,
            }))
          : [],
      }));
      setCollectionTableItemsduplicate(duplicated);
    }
  }, [CollectionTableItems, indexTableItem]);
  const arrFormat = () => {
    //  navigateCallback();
    console.log("Update Bill Data ", updateBillData);
    let cp = [...(updateBillData?.counterSalesChild ?? [])];
    let arr = [...(updateBillData?.counterSalesChild ?? [])].filter(
      (item, index, self) =>
        index === self.findIndex((obj) => obj.itemId === item.itemId)
    );
    let obj = { ...updateBillData };
    obj.counterSalesChild = arr;

    setPayloadCollection(cp);
    setbillData(obj);
  };
  useEffect(() => {
    arrFormat();
  }, []);
  const clearCollectionArray = () => {
    if (collectionTableItemsduplicate) {
      const updatedCollection = collectionTableItemsduplicate.map(
        (collection) => ({
          ...collection,
          tableItems: collection.tableItems
            ? collection.tableItems.map((it) => ({ ...it, quantity: 0 }))
            : [],
        })
      );
      setCollectionTableItemsduplicate(updatedCollection);
    }
  };
  const calculatedPriceWitrhDiscount = (amount, divideVal) => {
    let subVal = amount / divideVal;
    let afterCalculation = 0;
    if (billData.discount) {
      afterCalculation = amount - subVal;
    } else {
      afterCalculation = amount;
    }
    return afterCalculation;
  };
  const discoundedPrice = ({ allAmount, billData }) => {
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount;
    if (billData.discountType == "Amount") {
      divideVal = allAmount / billData.discount;
    }
    if (billData.discountType != "Amount") {
      let per = (allAmount * billData.discount) / 100;
      divideVal = allAmount / per;
    }

    return divideVal;
  };
  const addAllValue = (arr) => {
    let amount = 0;
    arr.forEach((item) => {
      amount += item.amount;
    });
    return amount;
  };
  const addAllAmount = () => {
    let add = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let payableAmount = 0;
    let allAmount = addAllValue(billData.counterSalesChild ?? []);
    let discountDivVal = 0;
    let divideVal = billData.discount
      ? allAmount / billData.discount
      : allAmount; //170/10=17

    // if(billData.discountType=="Amount"){
    //     divideVal=allAmount/billData.discount
    // }
    // if(billData.discountType!="Amount"){
    //   let per=allAmount*billData.discount/100;
    //     divideVal=allAmount/per
    // }
    divideVal = discoundedPrice({
      allAmount,
      billData,
    });
    billData?.counterSalesChild?.forEach((item) => {
      let subVal = item.amount / divideVal; //40/17
      let afterCalculation = 0;
      if (billData.discount) {
        afterCalculation = item.amount - subVal;
      } else {
        afterCalculation = item.amount;
      }
      console.log("afterCalculation ", afterCalculation);
      add += afterCalculation;
      cgst += (afterCalculation * (item.cgst ?? 1)) / 100;
      igst += (afterCalculation * (item.igst ?? 1)) / 100;
      sgst += (afterCalculation * (item.sgst ?? 1)) / 100;
    });

    return {
      sum: add,
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),
      payableAmount: add + cgst + sgst + igst,
    };
  };
  // .
  const discountD = () => {
    if (billData?.discountType === "Percent") {
      return parseFloat((billData?.discount / 100) * sumItemPrice().sum ?? 0);
    }

    if (billData?.discountType !== "Percent") {
      return parseFloat(billData?.discount ?? 0);
    }

    if (billData?.discountType !== "Percent") {
      return parseFloat(billData?.discount ?? 0);
    }

    if (billData?.discountType === "Amount" && billData?.discount === "") {
      return 0;
    }
    return 0;
  };

  // ...formatItem for update
  const formatItem = (ele) => ({
    ...ele,
    // id: 0,z
    itemId: ele?.itemId,
    itemDescription: ele?.itemDescription,
    unitPrice: ele?.rate,
    quantity: ele?.quantity,
    totalPrice: ele?.amount,
  });

  const filterDataForUpdate = () => {
    return;
  };
  return (
    <Box
      sx={{
        p: { sm: 0, xs: 0 },
        background: "#ececff",
        minHeight: "100vh",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <Box
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          borderRadius: "5px",
          color: "#01008B",
          display: "flex",
          fontFamily: "'Montserrat', sans-serif",
          fontSize: "20px",
          fontWeight: 500,
          alignItems: "center",
          justifyContent: "space-between",
          mx: 1,
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <ArrowBackIcon
            sx={{
              cursor: "pointer",
              fontSize: { xs: "14px", sm: "14px", md: "15px" },
            }}
            onClick={() => {
              setQuotationModal(false);
              setQuotationData(null);
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              fontWeight: 500,
            }}
          >
            Counter Sale Billing
          </Typography>
        </Box>
        {/* <Button
          // onClick={() => dispatch(setbillerMenuseletected(1))}
          variant="contained"
          sx={{ bgcolor: "#010093", fontWeight: 500, fontSize: "18px", mr: 1 }}
        >
          Previous Bills
        </Button> */}
      </Box>
      <Grid container spacing={1} p={{ sm: 2, xs: 2 }}>
        {/* Left colmn */}
        <Grid
          item
          xs={12}
          md={6}
          lg={5}
          backgroundColor={"#fff"}
          p={3}
          borderRadius={2}
          mt={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              fullWidth
              size="small"
              label="Search"
              value={searchItemValue}
              onChange={(e) => setSeachItemValue(e.target.value)}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                className: "mulish",
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
              }}
            />
            <Box>
              <CardMedia
                component="img"
                image={QRScanImage}
                alt="QRScanImage"
                sx={{ width: 35, height: 35 }}
              />
            </Box>
          </Box>
          {/* .. */}
          <MenuSideBar
            CollectionTableItems={CollectionTableItems}
            setCollectionTableItems={setCollectionTableItems}
            indexTableItem={indexTableItem}
            setIndexTableItem={setIndexTableItem}
          />
          <ItemSidebar
            CollectionTableItems={CollectionTableItems}
            indexTableItem={indexTableItem}
            billData={billData}
            setbillData={setbillData}
            collectionTableItemsduplicate={collectionTableItemsduplicate}
            setCollectionTableItemsduplicate={setCollectionTableItemsduplicate}
            searchItemValue={searchItemValue}
          />
        </Grid>

        {/* Right column */}
        <Grid item xs={12} md={6} lg={7}>
          <Grid backgroundColor={"#fff"} p={3} borderRadius={2} height={"72vh"}>
            <Grid container spacing={1}>
              {quotationData && (
                <Grid item xs={12} sm={4} md={12} lg={4} sx={{ p: "5px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Quotation No"
                    value={billData?.quotationNumber || ""}
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      className: "mulish",
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "#fff",
                      },
                    }}
                  />
                </Grid>
              )}

              <Grid
                item
                xs={quotationData ? 6 : 6}
                sm={quotationData ? 4 : 6}
                md={quotationData ? 6 : 6}
                lg={quotationData ? 4 : 6}
                sx={{ p: "5px" }}
              >
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date"
                      value={
                        billData?.quotationDate
                          ? dayjs(billData.quotationDate)
                          : null
                      }
                      onChange={(newValue) => {
                        // console.log(newValue);
                        let formattedDate =
                          dayjs(newValue).format("YYYY-MM-DD");
                        setbillData({
                          ...billData,
                          quotationDate: formattedDate,
                        });
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          InputLabelProps: {
                            className: "mulish",
                            sx: {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            },
                          },
                          InputProps: {
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end">
                                  <Box
                                    component="img"
                                    src={calendar}
                                    alt="calendar icon"
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                            classes: { input: "mulish" },
                            sx: {
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "15px",
                                // paddingRight: "40px",
                              },
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>

              <Grid
                item
                xs={quotationData ? 6 : 6}
                sm={quotationData ? 4 : 6}
                md={quotationData ? 6 : 6}
                lg={quotationData ? 4 : 6}
                sx={{ p: "1px" }}
              >
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Valid Till"
                      value={
                        billData?.validTill ? dayjs(billData.validTill) : null
                      }
                      onChange={(newValue) => {
                        console.log(newValue);
                        let formattedDate =
                          dayjs(newValue).format("YYYY-MM-DD");
                        setbillData({
                          ...billData,
                          validTill: formattedDate,
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          InputLabelProps: {
                            className: "mulish",
                            sx: {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            },
                          },
                          InputProps: {
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end">
                                  <Box
                                    component="img"
                                    src={calendar}
                                    alt="calendar icon"
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                            classes: { input: "mulish" },
                            sx: {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                spacing={1}
                sx={{ mt: 1 }}
              >
                <Grid item xs={8} sm={6} md={8} lg={4}>
                  <Button
                    sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                    variant="contained"
                    fullWidth
                    onClick={() => setOpenCustomerModal(true)}
                  >
                    Add Customer Info
                  </Button>
                </Grid>
              </Grid>
              <Modal
                open={openCustomerModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                {/* <DialogTitle>Add Customer Details</DialogTitle> */}
                <Box
                  sx={{
                    background: "white",
                    width: {
                      xs: "95%",
                      sm: "60%",
                      md: "52%",
                      lg: "40%",
                      xl: "40%",
                    },

                    overflowY: "auto",
                    // height: "50vh",
                    position: "absolute",
                    left: {
                      xs: "2%",
                      sm: "15%",
                      md: "25%",
                      lg: "30%",
                      xl: "30%",
                    },

                    top: { sm: "30%", xs: "20%" },
                    // borderRadius: "10px",
                  }}
                >
                  {" "}
                  <DialogTitle
                    color="primary"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "auto",
                      color: "#000000",
                      backgroundColor: "#CECEFF",
                      // padding: "10px 20px 10px 30px",
                      padding: "16px 24px",
                      fontFamily: "'Montserrat', sans-serif",
                      // borderRadius: "10px",
                      fontSize: { xs: "14px", sm: "15px", md: "20px" },

                      boxShadow: "0px 4px 4px #01008B4F;",
                    }}
                  >
                    Customer Information
                    <CloseIcon
                      sx={{ float: "left", cursor: "pointer" }}
                      onClick={() => setOpenCustomerModal(false)}
                    />
                  </DialogTitle>
                  <Grid item xs={18} sx={{ px: 3, py: 2 }}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Customer Name"
                      margin="dense"
                      value={billData?.customerName}
                      onChange={(e) => {
                        setbillData({
                          ...billData,
                          customerName: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                    <TextField
                      size="small"
                      fullWidth
                      label="Customer Address"
                      margin="dense"
                      value={billData?.customerAddress}
                      onChange={(e) => {
                        setbillData({
                          ...billData,
                          customerAddress: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                    <TextField
                      size="small"
                      fullWidth
                      label="Mobile Number"
                      margin="dense"
                      inputProps={{ maxLength: 10 }}
                      value={billData?.mobileNumber}
                      onChange={(e) => {
                        setbillData({
                          ...billData,
                          mobileNumber: e.target.value.replace(/\D/g, ""),
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Message to Print on Quotation"
                      margin="dense"
                      value={billData?.message}
                      onChange={(e) => {
                        setbillData({
                          ...billData,
                          message: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        borderBottom: "1px solid #01008B",
                        padding: "8px",
                        fontWeight: "600",
                        color: "#000000",
                        // mb: 1,
                        backgroundColor: "#f0f0ff",
                      }}
                    ></Box>
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                          setbillData({ ...billData });
                          setOpenCustomerModal(false);
                        }}
                        sx={{
                          height: "35px",
                          backgroundColor: "#14008B",
                          padding: "0px",
                        }}
                      >
                        {quotationData ? "Update" : "Save"}
                      </Button>
                    </Grid>
                  </Box>
                </Box>
              </Modal>
            </Grid>
            <Grid item xs={12}>
              <Box
                mt={2}
                sx={{
                  height: "24vh",
                  overflowY: "auto",
                  paddingRight: "10px",
                }}
              >
                {billData?.counterSalesChild?.length > 0 && (
                  <>
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        borderBottom: "2px solid #01008B",
                        padding: "8px 12px",
                        fontWeight: "600",
                        color: "#000000",
                        mb: 1,
                        backgroundColor: "#f0f0ff",
                      }}
                    >
                      <Box
                        sx={{
                          flex: 4,
                          color: "#01008B",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Services
                      </Box>
                      <Box
                        sx={{
                          flex: 3,
                          color: "#01008B",
                          textAlign: "center",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Price
                      </Box>
                      <Box
                        sx={{
                          flex: 2,
                          color: "#01008B",
                          textAlign: "center",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Qty
                      </Box>
                      <Box
                        sx={{
                          flex: 2,
                          color: "#01008B",
                          textAlign: "right",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Amount
                      </Box>
                      <Box sx={{ flex: 1 }} />
                    </Box>

                    {/* List Items */}
                    <Box>
                      {billData?.counterSalesChild?.map((item, index) => (
                        <React.Fragment key={"billitem" + index}>
                          {/* Item Row */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: "#EEEEFF",
                              borderRadius: 2,
                              mb: 1,
                              p: 1,
                            }}
                          >
                            <Box sx={{ flex: 4 }}>
                              <Typography
                                color={"#01008B"}
                                sx={{
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                {item?.itemDescription}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {displayPayloadcollection
                                  .filter((elet) => elet.itemId == item?.itemId)
                                  .map((eleTT, idx) => (
                                    <div key={"emp" + idx}>
                                      {eleTT.employeeName} (
                                      {eleTT.employeePayPercentage}%)
                                    </div>
                                  ))}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                flex: 3,
                                textAlign: "center",
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              ₹ {item?.rate}/{item?.unit}
                            </Box>

                            <Box
                              sx={{
                                flex: 2,
                                textAlign: "center",
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {item?.quantity}
                            </Box>

                            <Box
                              sx={{
                                flex: 2,
                                textAlign: "right",
                                color: "#01008B",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              ₹ {(item?.rate * item?.quantity).toFixed(2)}
                            </Box>

                            <Box
                              sx={{
                                flex: 1,
                                textAlign: "right",
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => {
                                  removeItem(index);
                                  removeFromPayloadCollection(
                                    billData?.counterSalesChild[index]
                                  );

                                  // Update quantity in collectionTableItemsduplicate
                                  if (
                                    collectionTableItemsduplicate &&
                                    collectionTableItemsduplicate[
                                      indexTableItem
                                    ] &&
                                    collectionTableItemsduplicate[
                                      indexTableItem
                                    ].tableItems
                                  ) {
                                    const updatedCollection = [
                                      ...collectionTableItemsduplicate,
                                    ];
                                    updatedCollection[indexTableItem] = {
                                      ...updatedCollection[indexTableItem],
                                      tableItems: updatedCollection[
                                        indexTableItem
                                      ].tableItems.map((it) =>
                                        it.id ===
                                        billData?.counterSalesChild[index]
                                          ?.itemId
                                          ? { ...it, quantity: 0 }
                                          : it
                                      ),
                                    };
                                    setCollectionTableItemsduplicate(
                                      updatedCollection
                                    );
                                  }
                                }}
                              >
                                <CancelIcon sx={{ color: "#01008B" }} />
                              </IconButton>
                            </Box>
                          </Box>
                        </React.Fragment>
                      ))}
                    </Box>
                  </>
                )}
              </Box>
            </Grid>

            {/* .Total */}
            <Box mt={2}>
              <Grid container>
                {/* Left column */}
                <Grid container spacing={{ xs: 1, sm: 3 }}>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={600}
                      >
                        Bill Amount:{" "}
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={500}
                      >
                        ₹ {TotalAmount(billData).amount}
                      </Typography>
                    </Box>
                    {/* .Comment Discount */}
                    {/* <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography
                      color={"#01008B"}
                       fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                      fontWeight={600}
                      onClick={() => {
                        setOpen2(true);
                      }}
                      sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      Discount :
                    </Typography>
                    <Typography
                      color={"#01008B"}
                       fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                      fontWeight={500}
                    >
                      ₹ {discountD()?.toFixed(2)}
                    </Typography>
                  </Box> */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        // mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={600}
                      >
                        CGST(%) :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={500}
                      >
                        ₹ {addAllAmount().cgst}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Right column */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={600}
                      >
                        SGST(%) :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={500}
                      >
                        ₹ {addAllAmount().sgst}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        // mb: 1,
                      }}
                    >
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={600}
                      >
                        IGST(%) :
                      </Typography>
                      <Typography
                        color={"#01008B"}
                        fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                        fontWeight={500}
                      >
                        ₹ {addAllAmount().igst}
                      </Typography>
                    </Box>
                    {/* <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography
                      color={"#01008B"}
                       fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                      fontWeight={600}
                    >
                      Payable Amount:
                    </Typography>
                    <Typography
                      color={"#01008B"}
                       fontSize={{
                          xs: "12px",
                          sm: "13px",
                          md: "15px",
                        }}
                      fontWeight={600}
                    >
                      ₹ {addAllAmount().payableAmount.toFixed(2)}
                    </Typography>
                  </Box> */}
                    {/* .center column */}
                    {/* <Grid item xs={6}> */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mb: 2,
                        mt: 1,
                      }}
                    >
                      <Grid container sx={{ maxWidth: 400 }}>
                        <Grid item xs={8}>
                          <Typography
                            fontWeight="600"
                            color="#01008B"
                            fontSize={{
                              xs: "12px",
                              sm: "13px",
                              md: "15px",
                            }}
                          >
                            Payable Amount:
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Typography
                            fontWeight="500"
                            color="#01008B"
                            fontSize={{
                              xs: "12px",
                              sm: "13px",
                              md: "15px",
                            }}
                          >
                            {" "}
                            ₹ {addAllAmount().payableAmount.toFixed(2)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                    {/* </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
              <Box sx={{ borderBottom: "2px solid #01008B" }}></Box>
            </Box>
            <Box
              sx={{
                display: "flex",
              }}
            >
              {NextBtnDisplay && (
                <React.Fragment>
                  <Button
                    variant="contained"
                    sx={{
                      width: "100%",
                      m: "10px",
                    }}
                    onClick={() => {
                      updateBillFunction();
                    }}
                  >
                    {" "}
                    Update
                  </Button>
                  {/* <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          m: "10px",
                        }}
                        onClick={() => {
                          // let valid = updateBillValidation(billData);
                          // if (valid.status) {
                          //   setOpen3(true);
                          // } else {
                          //   Swal.fire({
                          //     text: valid.msg,
                          //     icon: "warning",
                          //     ...swalAlertPopProps,
                          //   });
                          // }
                        }}
                      >
                        {" "}
                        Print
                      </Button> */}
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          m: "10px",
                        }}
                        // sx={{
                        //   // width: "50%",
                        //   mt: "10px",
                        //   display: "inline-block",
                        //   mb: "10px",
                        // }}
                        onClick={() => {
                          // setKOT();
                          // addDataCallBack();
                          // setOpen2(false);
                        }}
                      >
                        {" "}
                        Update
                      </Button>
                    )}
                    content={() => componentRef.current}
                    onBeforePrint={() => {
                      // setOpen2(false);
                      // addDataCallBack();
                      updateBillFunction();
                      // savePrintBill(
                      //   bill,
                      //   creditValidtionCheck,
                      //   Swal,
                      //   userDetail,
                      //   saveBill,
                      //   saveBillCbUser
                      // );
                    }}
                  ></ReactToPrint>
                </React.Fragment>
              )}
              {!NextBtnDisplay && (
                <Button
                  variant="contained"
                  sx={{
                    width: "100%",
                    m: "10px",
                  }}
                  onClick={() => {
                    // {
                    //   "id": 0,
                    //   "itemId": 2,
                    //   "quantity": 1,
                    //   "unitPrice": 130,
                    //   "totalPrice": 130
                    // }
                    const hasQuotationDate = !!billData?.quotationDate;
                    const hasValidTill = !!billData?.validTill;

                    // if (
                    //   !hasQuotationDate ||
                    //   !hasValidTill
                    // ) {
                    //   setDateErrors({
                    //     quotationDate: !hasQuotationDate,
                    //   });
                    //   // Show alert message
                    //   Swal.fire({
                    //     icon: "warning",
                    //     title: "Invalid Dates",
                    //     text: !hasQuotationDate
                    //       ? "Please select Quotation Date"
                    //       : !hasValidTill
                    //       ? "Please select Valid Till date"
                    //       : "Valid Till date must be after Quotation Date",
                    //   });
                    //   return; // stop submission
                    // }
                    const hasList = billData?.counterSalesChild?.length > 0;
                    const hasCustomerInfo =
                      billData.customerName &&
                      billData.customerAddress &&
                      billData.mobileNumber &&
                      billData.message;
                    if (!hasQuotationDate || !hasValidTill) {
                      setDateErrors({
                        quotationDate: !hasQuotationDate,
                      });
                      // Show alert message
                      Swal.fire({
                        icon: "warning",
                        title: "Invalid Dates",
                        text: !hasQuotationDate
                          ? "Please select Quotation Date"
                          : !hasValidTill
                          ? "Please select Valid Till date"
                          : "Valid Till date must be after Quotation Date",
                      });
                      return; // stop submission
                    }

                    if (!hasCustomerInfo) {
                      Swal.fire({
                        icon: "warning",
                        title: "Please Add Customer Info",
                        // text: "Fill All Customer",
                      });
                      return;
                    }

                    if (quotationData) {
                      updateQuetation(
                        {
                          ...billData,

                          customerName: billData?.customerName,
                          customerAddress: billData?.customerAddress,

                          igst: parseFloat(sumItemPrice().cgst),
                          sgst: parseFloat(sumItemPrice().sgst),
                          cgst: parseFloat(sumItemPrice().cgst),
                          billAmount: parseFloat(TotalAmount(billData).amount),
                          items: billData?.counterSalesChild?.map((item) => {
                            // Try to find match from quotationData.items (if updating)
                            const matchFromItems = quotationData?.items?.find(
                              (i) =>
                                i?.unitPrice === item?.rate &&
                                i?.quantity === item?.quantity
                            );

                            return {
                              itemId:
                                item?.itemId ??
                                item?.id ??
                                matchFromItems?.itemId ??
                                0,
                              itemDescription:
                                item?.itemDescription ??
                                matchFromItems?.itemDescription ??
                                "",
                              unitPrice:
                                item?.rate ?? matchFromItems?.unitPrice ?? 0,
                              quantity:
                                item?.quantity ?? matchFromItems?.quantity ?? 0,
                              totalPrice:
                                item?.amount ?? matchFromItems?.totalPrice ?? 0,
                            };
                          }),
                        },
                        (res) => {
                          setQuotationModal(false);
                          setQuotationData(null);

                          setbillData({
                            ...billData,
                            customerAddress: "",
                            mobileNumber: "",
                            customerName: "",
                            message: "",
                            validateDate: "",
                            validTill: "",
                            counterSalesChild: [],
                          });
                        }
                      );
                      console.log("updatessssssssss", billData);
                      // alert("billData:\n" + JSON.stringify(billData, null, 2));
                    } else {
                      addQuetation(
                        {
                          ...billData,

                          customerName: billData?.customerName,
                          customerAddress: billData?.customerAddress,

                          igst: parseFloat(sumItemPrice().cgst),
                          sgst: parseFloat(sumItemPrice().sgst),
                          cgst: parseFloat(sumItemPrice().cgst),
                          billAmount: parseFloat(TotalAmount(billData).amount),
                          items: billData?.counterSalesChild?.map(formatItem),
                          payableAmount: parseFloat(
                            addAllAmount().payableAmount.toFixed(2)
                          ),
                        },
                        (res) => {
                          setbillData({
                            ...billData,
                            customerAddress: "",
                            mobileNumber: "",
                            customerName: "",
                            message: "",
                            validateDate: "",
                            validTill: "",
                            counterSalesChild: [],
                          });
                        }
                      );
                    }

                    // setOpen4(true);
                  }}
                >
                  {" "}
                  {quotationData ? "Update" : "Save"}
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
        {/* ... */}
      </Grid>

      <DiscountModal
        open={open2}
        handleClose={handleClose2}
        bill={{
          ...billData,

          discount: billData.discount,
          discountType: billData?.discountType
            ? billData?.discountType
            : "Amount",
          amount: TotalAmount(billData).priceWithoutGst,
          // amount:billData.netAmount?billData.netAmount:billData.amount,
          paybill: billData.netAmount ? billData.netAmount : billData.amount,
        }}
        setBill={(data) => {
          for (let prop in data) {
            // if (!billData.hasOwnProperty(prop)) {
            // }
          }
          setbillData((prev) => {
            let prevData = { ...prev, ...data };

            // prevData.amount = data.amount === NaN ? 0 : data.amount;
            return prevData;
          });
        }}
        setOpen={setOpen2}
      />
      <PrintBilling
        open2={open3}
        handleClose2={handleClose3}
        componentRef={componentRef}
        currentDataArr={billData?.counterSalesChild}
        tableName={tableName}
        priceWithoutGst={TotalAmount(billData).priceWithoutGst}
        // setKOT={setKOT}
        // setBill={setBill}
        setOpen2={setOpen3}
        addDataCallBack={() => {
          updateBil(
            {
              ...billData,
              discount: billData?.discount ? parseFloat(billData?.discount) : 0,
            },
            UpdateBillCounterSell,
            Swal,
            navigate,
            routePath
          );
        }}
        payableBilUpdateBill={payableValueCalculate}
        paybill={payableValueCalculate()}
        paymentAttribute={sumItemPrice()}
        userDetail={userDetail}
        discountType={billData?.discountType}
        discount={1}
        totalAmountBill={TotalAmount(billData).amount}
        discountAmount={
          (function () {
            if (billData?.discountType === "Percent") {
              return (billData?.discount / 100) * sumItemPrice().sum;
            }
            return billData?.discount;
          })()
          // billData?.discount
        }
        addtoCardProductCBUser={billData?.counterSalesChild}
      />
      <Pop
        open={open4}
        setOpen={setOpen4}
        data={billData?.counterSalesChild}
        arrCollectionCb={(data) => {
          setDisplayContinue(true);
          setPayloadCollection(data);
        }}
        NextDisplayCb={(data) => {
          setNextBtnDisplay(data);
        }}
        eleCompairedIndex={1}
      />
    </Box>
  );
}
